import {Component, OnInit} from '@angular/core';
import {Set} from "../../model/set";
import {User} from "../../model/user";
import {GroupCreateService} from "./group-create.service";
import {FormMode} from "./form-mode.enum";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {SafeDomain} from "../../model/safe-domain";
import {Group} from "../../model/group";
import {forkJoin} from "rxjs/observable/forkJoin";
import {NotifierService} from "../notifier/notifier.service";
import {NotificationType} from "../notifier/notification-type.enum";
import * as Promise from "bluebird";
import {CreateGroupStep} from "./create-group-step.enum";
import {BackendServiceResponse} from "../../model/backend-service-response";
import {Observable} from "rxjs";
import {HeaderService} from "../header/header.service";

@Component({
  selector: 'pbc-group-create',
  templateUrl: './group-create.component.html'
})
export class GroupCreateComponent implements OnInit {

  private setsToAssign : Array<Set> = [];
  private setsToAssignMoreLess : Array<Set> = [];
  private setsToAssignSelected : Array<Set> = [];
  private setsIdsToAssignSelected : Array<number> = [];

  private assignUsersFromGroup : boolean = false;
  private groupsToAssignUsersFrom : Array<Group> = [];
  private groupsToAssignUsersFromSelected : Array<Group> = [];
  private groupsToAssignUsersFromMoreLess : Array<Group> =[];
  private usersFromGroupsToAssignUsersFrom : Array<User> = [];
  private usersForFinalAccept : Array<User> = [];

  private selfRegisterFromDomain : boolean = false;
  domainsToAssign : Array<SafeDomain> = [];
  newDomainsToAssign : Array<SafeDomain> = [];//W trybie edycji grupy, jeśli dodamy nowe domeny
  usersFromDomainsToAssign : Array<User> = [];

  formModeEnum = FormMode;

  //Tworzenie/edycja nowego zestawu
  private createEditGroupForm : FormGroup;
  createGroupStepEnum = CreateGroupStep;

  private usersToAssignToGroup : Array<User> = [];
  private usersToAssignToGroupSelected : Array<User> = [];

  private sendNotification : boolean = false;

  private usersFromOutsideToCreateGroup : Array<User> = [];
  private groupForOperations : Group;
  createEditGroupFormMode : FormMode;
  createEditGroupStep : CreateGroupStep = undefined;

  private readonly MORE_LESS_LIMIT : number = 5;

  constructor(private groupCreateService: GroupCreateService,
              private headerService : HeaderService,
              private notifierService : NotifierService
              ) { }

  ngOnInit() {
    this.headerService.hideLoginRegisterButtons();

    this.createEditGroupForm = new FormGroup({
      groupName : new FormControl('', Validators.required),
      safeDomains : new FormArray([])
    });

    this.groupCreateService.usersToAssignChanged.subscribe((users : Array<User>)=>{
      this.usersFromOutsideToCreateGroup = users;
    });

    this.groupCreateService.groupChanged.subscribe((group : Group)=> {
      if (group) {
        this.groupForOperations = group;
        this.createEditGroupForm.controls['groupName'].setValue(group.name);
        if (group.safedomains.length > 0) {
          this.selfRegisterFromDomain = true;
          group.safedomains.forEach(
            domain=> {
              this.createNewSafeDomainInput(domain);
            }
          )
        }
        this.sendNotification = this.groupForOperations.sendNotification;
        this.setsToAssignSelected = this.groupForOperations.sets;
        this.setsIdsToAssignSelected = this.groupForOperations.sets.map(set=>set.id);
      } else {
        this.groupForOperations = undefined;
        this.setsToAssignSelected = [];
        this.setsIdsToAssignSelected = [];
        this.selfRegisterFromDomain = false;
        this.domainsToAssign = [];
        this.usersFromDomainsToAssign = [];
      }
    });

    this.groupCreateService.formModeChanged.subscribe((formMode: FormMode)=>{
      this.createEditGroupFormMode = formMode;
    });

    this.groupCreateService.createStepChanged.subscribe((createEditGroupStep : CreateGroupStep)=>{
      this.createEditGroupStep = createEditGroupStep;
      if (createEditGroupStep == CreateGroupStep.Definition)
        this.getAssetsFromDatabase();
    });
  }

  getAssetsFromDatabase() {
    forkJoin(
        this.groupCreateService.getGroups(),
        this.groupCreateService.getSets()
    ).subscribe(([groupsResponse, setsResponse])=>{
      if (groupsResponse.status == 'OK') {
        this.groupsToAssignUsersFrom = groupsResponse.record;
        if (this.groupsToAssignUsersFrom.length > this.MORE_LESS_LIMIT)
          this.groupsToAssignUsersFromMoreLess = this.groupsToAssignUsersFrom.slice(0, this.MORE_LESS_LIMIT-1);
        else
          this.groupsToAssignUsersFromMoreLess = this.groupsToAssignUsersFrom;
      }
      else
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można pobrać listy grup");

      if (setsResponse.status == 1) {
        this.setsToAssign = setsResponse.record;
        if (this.setsToAssign.length > this.MORE_LESS_LIMIT) {
          this.setsToAssignMoreLess = this.setsToAssign.slice(0, this.MORE_LESS_LIMIT-1)
        } else {
          this.setsToAssignMoreLess = this.setsToAssign;
        }
      }
      else
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można pobrac listy zestawow");
    });
  }

  private modifySetsToAssignSelected(set : Set) {
    let setPosition = this.setsIdsToAssignSelected.indexOf(set.id);
    if (setPosition == -1) {
      this.setsToAssignSelected.push(set);
      this.setsIdsToAssignSelected.push(set.id)
    }
    else {
      this.setsIdsToAssignSelected.splice(setPosition, 1);
      this.setsToAssignSelected.splice(setPosition, 1);
    }
  }

  private modifyGroupsToAssignUsersFromSelected(group : Group) {
    let groupPosition = this.groupsToAssignUsersFromSelected.indexOf(group);
    if (groupPosition == -1)
      this.groupsToAssignUsersFromSelected.push(group);
    else
      this.groupsToAssignUsersFromSelected.splice(groupPosition, 1);
  }

  private modifyUsersForFinalAccept(user : User) {
    let userPosition = this.usersForFinalAccept.indexOf(user);
    if (userPosition == -1)
      this.usersForFinalAccept.push(user);
    else
      this.usersForFinalAccept.splice(userPosition, 1);
  }

  private groupExists(groupName : string, id? : number) : Promise<boolean> {
    return new Promise<boolean>((resolve, reject)=>{
      this.groupCreateService.groupExists(groupName, id).subscribe(
        response=>{
          if (response.status == 1)
            resolve(response.message);
          else
            reject();
        },
        error => {
          reject(error);
        }
      )
    });
  }

  private closeCreateUpdateGroup() {
    this.resetCreateEditGroupForm();
    this.createEditGroupStep = CreateGroupStep.Undefined;
    this.createEditGroupFormMode = undefined;
    this.groupCreateService.groupChanged.next(undefined);
  }

  private resetCreateEditGroupForm() {
    this.selfRegisterFromDomain = false;
    this.assignUsersFromGroup = false;

    this.domainsToAssign = [];

    this.usersToAssignToGroup = [];
    this.usersToAssignToGroupSelected = [];
    this.groupsToAssignUsersFromSelected =[];
    (<FormArray>this.createEditGroupForm.controls['safeDomains']) = new FormArray([]);
    this.sendNotification = false;
    this.createEditGroupForm.controls['groupName'].reset();
  }

  /**
   * Jeśli zaznaczymy możliwość dodania domeny
   */
  private modifySelfRegisterFromDomain() {
    this.selfRegisterFromDomain = !this.selfRegisterFromDomain;
    if (this.selfRegisterFromDomain) {
      this.createNewSafeDomainInput();
    } else {
      (<FormArray>this.createEditGroupForm.controls['safeDomains']) = new FormArray([]);
      this.domainsToAssign = [];

      //Jesli w trybie edycji wyłączymy dla grupy bezpiezcne domeny, trzeba wyczyścić ich listę w pierwotnym obiekcie,
      // ponieważ lista ta służy potem do sprawdzenia, czy podano jakieś nowe domeny.
      if (this.createEditGroupFormMode == FormMode.EDIT && this.groupForOperations)
        this.groupForOperations.safedomains = [];
    }
  }

  /**
   * Dodaje kolejny blok umożliwiajacy dodanie domeny
   */
  private createNewSafeDomainInput(domain? : SafeDomain) {
    if (domain) {
      (<FormArray>this.createEditGroupForm.controls['safeDomains']).push(
        new FormGroup({
          name: new FormControl({value: domain.name, disabled: true}, Validators.required),
          id: new FormControl(domain.id),
          logoFileToUpload: new FormControl()
        })
      );
      this.pushNewDomainToAssign(domain);
    }
    else {
      (<FormArray>this.createEditGroupForm.controls['safeDomains']).push(
        new FormGroup({
          name: new FormControl('', Validators.required),
          id: new FormControl(),
          logoFileToUpload: new FormControl()
        })
      );

      this.pushNewDomainToAssign();
    }
  }

  /**
   * Tworzy nowy wpis w rejestrze domen do przypisania do grupy
   */
  private pushNewDomainToAssign(domain? : SafeDomain) {
    if (domain)
      this.domainsToAssign.push(domain);
    else
      this.domainsToAssign.push({
        id :null,
        name:'',
        logoFileName :'',
        logoFileToUpload: undefined,
        logoRepositoryFileName:'',
        group:''
      });
  }

  private modifyAssignUsersFromGroup() {
    this.assignUsersFromGroup = !this.assignUsersFromGroup;
    if (!this.assignUsersFromGroup) {
      this.usersToAssignToGroup = [];
      this.groupsToAssignUsersFromSelected = [];
    }
  }

  private setsToAssignMoreLessClick() {
    if (this.setsToAssignMoreLess.length < this.setsToAssign.length) {
      this.setsToAssignMoreLess = this.setsToAssign;
    } else {
      this.setsToAssignMoreLess = this.setsToAssign.slice(0, this.MORE_LESS_LIMIT-1);
    }
  }

  private groupsToAssignUsersFromMoreLessClick() {
    if (this.groupsToAssignUsersFromMoreLess.length < this.groupsToAssignUsersFrom.length) {
      this.groupsToAssignUsersFromMoreLess = this.groupsToAssignUsersFrom;
    } else {
      this.groupsToAssignUsersFromMoreLess = this.groupsToAssignUsersFrom.slice(0, this.MORE_LESS_LIMIT-1)
    }
  }

  //Dla trybu edycji trzeba sprawdzić, czy podano jakieś nowe domeny
  private getNewSafeDomains() : Array<SafeDomain> {
    let newDomains : Array<SafeDomain> = [];
    let existingSafeDomainsNames = this.groupForOperations.safedomains.map(safedomain=>safedomain.name);
    let editedSafeDomainsNames = this.domainsToAssign.map(safedomain => safedomain.name);

    for (let i = 0; i < editedSafeDomainsNames.length; i++) {
      if (existingSafeDomainsNames.indexOf(editedSafeDomainsNames[i]) == -1)
        newDomains.push({
          id : null,
          name : this.domainsToAssign[i].name,
          logoFileName : this.domainsToAssign[i].logoFileName,
          logoRepositoryFileName : '',
          logoFileToUpload : this.domainsToAssign[i].logoFileToUpload,
          group : ''
        });
    }

    return newDomains;
  }

  private createGroupNextStep() {
    let index = 0;

    (<Array<SafeDomain>>this.createEditGroupForm.controls['safeDomains'].value).forEach(domain=>{
      this.domainsToAssign[index].name = domain.name;
      index++;
    });

    //Trick: Jeśli nie wskażemy w wywołaniu do backendu przynajmniej jednej domeny, to otrzymamy wszystkich userow.
    //Trzeba wyslac przynajmniej jedna domene, w przypadku, kiedy nie wiążemy grupy z jakimiś domenami
    let domainsForFilteringUsers : Array<SafeDomain> = [];
    let nonExistingDomain = 'nonexistingdomain';

    switch (this.createEditGroupFormMode) {
      case FormMode.CREATE: {
        if (this.domainsToAssign.length == 0)
          domainsForFilteringUsers.push({
            id : null,
            name : nonExistingDomain,
            logoFileName : '',
            logoRepositoryFileName : '',
            logoFileToUpload : undefined,
            group : ''
          });
        else
          domainsForFilteringUsers = this.domainsToAssign;
        break;
      }

      case FormMode.EDIT: {
        this.newDomainsToAssign = this.getNewSafeDomains();
        if (this.newDomainsToAssign.length > 0)
          domainsForFilteringUsers = this.newDomainsToAssign;
        else
          domainsForFilteringUsers.push({
            id : null,
            name : nonExistingDomain,
            logoFileName : '',
            logoRepositoryFileName : '',
            logoFileToUpload : undefined,
            group : ''
          });
        break;
      }
    }

    if (this.createEditGroupStep == CreateGroupStep.Definition) {
      let groupMame = this.createEditGroupForm.controls['groupName'].value.toString().trim();
      let groupId : number = -997;
      if (this.createEditGroupFormMode == FormMode.EDIT)
        groupId = this.groupForOperations.id;
      this.groupExists(groupMame, groupId).then(
          result=>{
            if (result)
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                  "Taka grupa już istnieje w systemie");
            else
              forkJoin(
                  this.groupCreateService.getUsersByGroups(this.groupsToAssignUsersFromSelected),
                  this.groupCreateService.getUsersByDomains(domainsForFilteringUsers)
              ).subscribe(([usersByGroupsResponse, usersByDomainsResponse])=> {
                if (usersByDomainsResponse.status == 'ok')
                  this.usersFromDomainsToAssign = usersByDomainsResponse.record;
                else
                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                    "Wystąpił błąd! Nie można pobrać listy użytkowników z wskazanych domen");

                if (usersByGroupsResponse.status == 'ok')
                  this.usersFromGroupsToAssignUsersFrom = usersByGroupsResponse.record;
                else
                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                    "Wystąpił błąd ! Nie można pobrać użytkowników z wskazanych grup");

                if (usersByDomainsResponse.status == 'ok' && this.usersFromDomainsToAssign.length > 0)
                  this.createEditGroupStep = CreateGroupStep.UsersFromDomains;
                else
                  this.moveToFinalConfirmation(false);
              })
          },
          error=>{
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Nie można sprawdzić czy grupa o podanej nazwie istnieje");
          }
      )
    }
  }

  private moveToDefinition() {
    this.cleanFileUploadControls();
    this.createEditGroupStep = CreateGroupStep.Definition;
  }

  private moveToFinalConfirmation(copyDomainUsers : boolean) {
    let usersIdsToAssignToGroup = this.usersToAssignToGroup.map(user=>user.id);

    //Kopiowanie uzytkownikow z zewnetrznej listy
    for (let i = 0; i< this.usersFromOutsideToCreateGroup.length; i++)
      if (usersIdsToAssignToGroup.indexOf(this.usersFromOutsideToCreateGroup[i].id) == -1) {
        this.usersToAssignToGroup.push(this.usersFromOutsideToCreateGroup[i]);
        usersIdsToAssignToGroup.push(this.usersFromOutsideToCreateGroup[i].id);
      }

    //Kopiowanie uzytkownikow z zaznaczonych grup
    for (let i = 0; i < this.usersFromGroupsToAssignUsersFrom.length; i++)
      if (usersIdsToAssignToGroup.indexOf(this.usersFromGroupsToAssignUsersFrom[i].id) == -1) {
        this.usersToAssignToGroup.push(this.usersFromGroupsToAssignUsersFrom[i]);
        usersIdsToAssignToGroup.push(this.usersFromGroupsToAssignUsersFrom[i].id);
      }

    //Kopiowanie uzytkownikow z domen
    if (copyDomainUsers) {
      for (let i = 0; i < this.usersFromDomainsToAssign.length; i++)
        if (usersIdsToAssignToGroup.indexOf(this.usersFromDomainsToAssign[i].id) == -1) {
          this.usersToAssignToGroup.push(this.usersFromDomainsToAssign[i]);
          usersIdsToAssignToGroup.push(this.usersFromDomainsToAssign[i].id);
        }
    }

    this.usersToAssignToGroupSelected = this.usersToAssignToGroupSelected.concat(this.usersToAssignToGroup);

    this.createEditGroupStep = CreateGroupStep.FinalConfirmation;
  }

  private modifySendNotification() {
    this.sendNotification = !this.sendNotification;
  }


  /**
   * Tworzy grupę użytkownikóœ wg zebranych wcześniej informacji.
   */
  private createGroup() {

    let domainsToAssignCreateResults : Array<Observable<BackendServiceResponse<number, SafeDomain>>> = [];
    let domainsCreatedIds : Array<number> = [];

    let group : any = {};
    group.users = this.usersToAssignToGroupSelected.map(user=>user.id);
    group.sets = this.setsToAssignSelected.map(set=>set.id);
    group.safeDomains = domainsCreatedIds;

    group.name = this.createEditGroupForm.controls['groupName'].value.toString().trim();
    group.sendNotification = this.sendNotification;

    if (this.domainsToAssign.length > 0) {

      this.domainsToAssign.forEach((domain : SafeDomain)=>{
        domainsToAssignCreateResults.push(this.groupCreateService.createSafeDomain(domain));
      });

      forkJoin(domainsToAssignCreateResults).subscribe((results : Array<BackendServiceResponse<number, SafeDomain>>)=>{

        results.forEach((response : BackendServiceResponse<number, SafeDomain> )=>{
          if (response.status != 1) {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Grupa użytkowników nie została dodana. Spróbuj jeszcze raz");
            return;
          } else {
            domainsCreatedIds.push(response.record.id);
          }
        });

        group.safedomains = domainsCreatedIds;

        this.groupCreateService.createGroup(group).subscribe(
          response => {
            if (response.status != 'ok') {
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Grupa użytkowników nie została dodana. Spróbuj jeszcze raz.");
              this.groupCreateService.groupAddedOrModifiedEmit(false);
            }
            else {
              this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                "Grupa ".concat(response.record[0].name, " użytkowników została poprawnie dodana"));
              this.groupCreateService.groupAddedOrModifiedEmit(true);
            }
          },
          error => {
            console.log(error);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Grupa użytkowników nie została dodana. Spróbuj jeszcze raz.");
            this.groupCreateService.groupAddedOrModifiedEmit(false);
          }
        );

      });
    } else {
      this.groupCreateService.createGroup(group).subscribe(
        response => {
          if (response.status != 'ok') {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Grupa użytkowników nie została dodana. Spróbuj jeszcze raz.");
            this.groupCreateService.groupAddedOrModifiedEmit(false);
          }
          else {
            this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
              "Grupa ".concat(response.record[0].name, " użytkowników została poprawnie dodana"));
            this.groupCreateService.groupAddedOrModifiedEmit(true);
          }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Grupa użytkowników nie została dodana. Spróbuj jeszcze raz.");
          this.groupCreateService.groupAddedOrModifiedEmit(false);
        }
      );

    }

    this.closeCreateUpdateGroup();
  }

  private fileChanged(event:any, numberOfDomain? : number) {
    if (event.target.files.length > 0) {
      this.domainsToAssign[numberOfDomain].logoFileToUpload = <File>event.target.files[0];
      this.domainsToAssign[numberOfDomain].logoFileName = this.domainsToAssign[numberOfDomain].logoFileToUpload.name;
    }
  }

  /**
   * Dodaje - usuwa użytkownika z listy użytkowników do przypisania do grupy.
   * @param user
   */
  private modifyUsersToAssignToGroupSelected(user : User) {
    let userPosition = this.usersToAssignToGroupSelected.indexOf(user);
    if (userPosition  == -1) {
      this.usersToAssignToGroupSelected.push(user)
    } else {
      this.usersToAssignToGroupSelected.splice(userPosition, 1);
    }
  }

  private backFromFinalConfirmation() {
      this.usersToAssignToGroup = [];
      this.cleanFileUploadControls();
      if (this.usersFromDomainsToAssign.length > 0)
        this.createEditGroupStep = CreateGroupStep.UsersFromDomains;
      else
        this.createEditGroupStep = CreateGroupStep.Definition;
  }

  private updateGroup() {
    let group: any = {};
    let domainsToUpdateOrCreate: Array<Observable<BackendServiceResponse<number, SafeDomain>>> = [];

    //do kolejki requestow wstawiam te, które utworzą nowe domeny
    this.newDomainsToAssign.forEach(domain => {
      domainsToUpdateOrCreate.push(this.groupCreateService.createSafeDomain(domain));
    });

    //Jeśli w domenach przypisanych do grupy zaszły jakieś zmiany - tu je wykrywamy wstawiamy do utrwalenia w bazie
    this.groupForOperations.safedomains.forEach(safeDomain => {
      if (safeDomain.logoFileToUpload)
        domainsToUpdateOrCreate.push(this.groupCreateService.updateSafeDomain(safeDomain));
    });

    group.name = this.createEditGroupForm.controls['groupName'].value.toString().trim();
    group.sets = this.setsIdsToAssignSelected;
    group.id = this.groupForOperations.id;
    group.users = this.usersToAssignToGroupSelected.map(user=>user.id);

    //dodajemu do update userow tych, którzy juz byli w grupie
    group.users = group.users.concat(this.groupForOperations.users.map(user=>user.id));

    group.safedomains = [];

    this.domainsToAssign.forEach(domain=>{
      if (domain.id != null)
        group.safedomains.push(domain.id);
    });

    group.sendNotification = this.sendNotification;

    if (domainsToUpdateOrCreate.length > 0)
      forkJoin(domainsToUpdateOrCreate).subscribe(
          (results: Array<BackendServiceResponse<number, SafeDomain>>)=>{
            results.forEach(
                result=>{
                  if (result.status != 1) {
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Nie zaktualizowany grupy: Błąd przy aktualizacji domen");
                    return;
                  } else
                      group.safedomains.push(result.record.id);
                }
            );

            this.groupCreateService.updateGroup(group).subscribe(
                response => {
                  if (response.status !== 1) {
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: nie zaktualizowano danych grupy");
                    this.groupCreateService.groupAddedOrModifiedEmit(false);
                  } else {
                    this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Zaktualizowano grupę ".concat(group.name));
                    this.groupCreateService.groupAddedOrModifiedEmit(true)
                  }
                },
                error => {
                  console.log(error);
                  this.groupCreateService.groupAddedOrModifiedEmit(false);
                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie aktualizacji grupy");
                }
            );
          },
      );
    else
      this.groupCreateService.updateGroup(group).subscribe(
          response => {
            if (response.status !== 1) {
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: nie zaktualizowano danych grupy");
              this.groupCreateService.groupAddedOrModifiedEmit(false);
            } else {
              this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Zaktualizowano grupę ".concat(group.name));
              this.groupCreateService.groupAddedOrModifiedEmit(true)
            }
          },
          error => {
            console.log(error);
            this.groupCreateService.groupAddedOrModifiedEmit(false);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie aktualizacji grupy");
          }
      );

    this.closeCreateUpdateGroup();
  }

  //Technicznie - przed przejście do 1 kroku tworzenia grupy, trzeba wyczyścić kontrolkę file, żeby nie generowała błędu
  private cleanFileUploadControls() {
    let safeDomains : FormArray = <FormArray> this.createEditGroupForm.controls['safeDomains'];
    safeDomains.controls.forEach((control : FormGroup)=>{
      control.controls['logoFileToUpload'].setValue("");
    });
  }
}
